import React from 'react'
import CountUp from 'react-countup'
import styled from 'styled-components'

const CountUpContainer = styled.div`
  text-align: center;
`

const CountUpTitle = styled.p`
  font-size: 18px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin-bottom: 0;
`

const Counter = styled(CountUp)`
  font-size: 40px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`

const Count = ({ start, end, title }) => {
  return (
    <CountUpContainer>
      <Counter start={start} end={end} />
      <CountUpTitle>{title}</CountUpTitle>
    </CountUpContainer>
  )
}

export default Count



// WEBPACK FOOTER //
// ./src/components/countup/countup.js